import { render } from "./StatisticsOrders.vue?vue&type=template&id=c761988e&scoped=true"
import script from "./StatisticsOrders.vue?vue&type=script&lang=js"
export * from "./StatisticsOrders.vue?vue&type=script&lang=js"

import "./StatisticsOrders.vue?vue&type=style&index=0&id=c761988e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c761988e"

export default script